@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.contract.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.contract.contract_number' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.Contract"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.contract.contract_date' | translate }}
    </div>
    <div>
      <tui-textfield xIsoStringTuiDateTransformer tuiTextfieldSize="m">
        <input
          tuiInputDate
          type="date"
          [formControlName]="FormFields.ContractDate"
          [readOnly]="readOnly"
          placeholder="{{
            'request_form.common.contract.select_date_placeholder' | translate
          }}"
        />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.contract.contract_planned_end_date' | translate }}
    </div>
    <div>
      <tui-textfield xIsoStringTuiDateTransformer tuiTextfieldSize="m">
        <input
          tuiInputDate
          type="date"
          [formControlName]="FormFields.ContractPlannedEndDate"
          [readOnly]="readOnly"
          placeholder="{{
            'request_form.common.contract.select_planned_end_date_placeholder'
              | translate
          }}"
        />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.contract.contract_early_end_date' | translate }}
    </div>
    <div>
      <tui-textfield xIsoStringTuiDateTransformer tuiTextfieldSize="m">
        <input
          tuiInputDate
          type="date"
          [formControlName]="FormFields.ContractEarlyEndDate"
          [readOnly]="readOnly"
          placeholder="{{
            'request_form.common.contract.select_early_end_date_placeholder'
              | translate
          }}"
        />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>
  </div>
</form>
